export const THEMES = {
  LIGHT: 'theme-light',
  DARK: 'theme-dark',
};
